import { useCallback } from 'react';
import { useFormikContext } from 'formik';
import { selectModelTypeFieldTypeInfo } from 'modules/Models/components/ModelForm/utils/utils';
import { formContainer, inputContainer } from 'modules/Models/components/ModelForm/styles';
import { FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { SelectFormElement } from './SelectFormElement';

type SelectEnumFormElementProps = React.InputHTMLAttributes<HTMLInputElement> & { path: string };

export const SelectEnumFormElement = ({ path }: SelectEnumFormElementProps) => {
  const { values, setFieldValue } = useFormikContext();
  const { fieldValueMap } = values as FormikInitialValues;
  const { description = '', placeholder = '', model_type_enum_options = [] } = selectModelTypeFieldTypeInfo(path, values as FormikInitialValues);
  const inputValue = fieldValueMap[path];

  const onChange = useCallback(
    (e) => {
      setFieldValue('fieldValueMap', { ...fieldValueMap, [path]: e.value });
    },
    [fieldValueMap, path],
  );

  return (
    <div className={formContainer}>
      <div className={inputContainer}>
        <SelectFormElement
          path={path}
          description={description as string}
          placeholder={placeholder}
          selectOptions={model_type_enum_options || []}
          value={inputValue as string}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
